import {
    doScrollToTop
} from './_scroll';
export const submitForm = () => {
    
    $("#saveShippingAddressButton").click(function(event) {
        //------Check Contact Form Validation--------->
         if ($('#contactInfoInputWrapper').is(':visible')) {
              Dillards.validateThisForm($('#contactInfoInputWrapper'));
             $('#contactInfoInputWrapper button').eq(0).click();
             event.preventDefault();
         }
         if ($('#contactInfoInputWrapper .has-error').length > 0) {
            var inputString = $('#contactPhone').val();
            var returnString = '';
            if (inputString.length > 0) {
                returnString = `(${inputString.substring(0, 3)}`;
            }
            if (inputString.length > 3) {
                returnString += `) ${inputString.substring(3, 6)}`;
            }
            if (inputString.length > 6) {
                returnString += `-${inputString.substring(6)}`;
            }
            $('#contactPhone').val(returnString);
 
            return false;
         }
         //------/Check Contact Form Validation---------> 
     });
      
    //Single pageForm/modals
    $("#shippingAddressForm input").keydown(function(event) {
        if (event.keyCode == 13) {
            $("#saveShippingAddressButton").click();
            event.preventDefault();
        }
    });
    $("#contactInfoInputWrapper input").keydown(function(event) {
        if (event.keyCode == 13) {
            Dillards.validateThisForm($('#contactInfoInputWrapper'));
            $('#contactInfoInputWrapper button').eq(0).click();
            event.preventDefault();
        }
    });

    //Otherwise List each form
    $("#OHOOEmail").keydown(function(event) {
        if (event.keyCode == 13) {
            $("#OHOOContinueButton").trigger('click');
            event.preventDefault();
        }
    });

    $('#giftCcard').keydown(function(event) {
        if (event.keyCode == 13) {
            $(".apply-btn").click();
            event.preventDefault();
        }
    });

    $('#gcPin').keydown(function(event) {
        if (event.keyCode == 13) {
            $(".apply-btn").click();
            event.preventDefault();
        }
    });

    $('#certificate-pass-promo-code').keydown(function(event) {
        if (event.keyCode == 13) {
            $(".promo-btn").click();
            event.preventDefault();
        }
    });
    
    $("#qcCreditCard input").keydown(function(event) {
        if (event.keyCode == 13) {
            $('.ccSubmit').click();
            event.preventDefault();
        }
    });

    $("#creditCardForm input").keydown(function(event) {
        if (event.keyCode == 13) {
            $('.ccSubmit').click();
            event.preventDefault();
        }
    });

    $('#lookupForm-GCB input').keydown(function(event) {
        if (event.keyCode == 13) {
            $('#get-balance-btn').click();
            doScrollToTop();
            event.preventDefault();
        }
    });

    $("form[name='forgotPasswordForm'] input").keydown(function(event) {
        if (event.keyCode == 13) {
            $("button[data-twist='submit-button']").click();
            event.preventDefault();
        }
    });

};
